<template>
  <v-container class="py-10 py-md-13 py-lg-16">
    <TitleWidget>{{ title }}</TitleWidget>
    <v-sheet color="transparent" class="mt-4 mt-md-6 mx-auto" max-width="500">
      <ContactForm />
    </v-sheet>
  </v-container>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import ContactForm from "../components/forms/ContactForm.vue";

const _data = {
  title: "Fale Conosco",
};

export default {
  data: () => ({
    ..._data,
  }),
  components: {
    TitleWidget,
    ContactForm,
  },
};
</script>
